import React, { useEffect, useState } from 'react';
import { withRouter } from "../hooks/withRouter";
import { getRppDetalle } from '../api/consultaRppApi';
import { Link } from "react-router-dom";
import { UseAuth } from "../hooks/useAuth";

function BusquedaRppDetalles(props) {
    const { location } = props.router;
    const { accessToken } = UseAuth();
    const [result, setResult] = useState([]);
    const [isSearching, setIsSearching] = useState(true); // Estado para controlar la búsqueda

    const url = location.pathname.split("/");
    const id = url[2];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsSearching(true); // Comenzamos la búsqueda
                const response = await getRppDetalle(accessToken, id);
                setResult(response);
            } catch (error) {
                console.error("Error al obtener los detalles:", error);
            } finally {
                setIsSearching(false); // Finalizamos la búsqueda
            }
        };

        fetchData();
    }, [accessToken, id]);

    const formatDate = (date) => {
        if (!date) return ""; // Manejar fechas nulas o indefinidas
        // Convertir la fecha a un objeto Date
        const formattedDate = new Date(date);
        // Obtener el día, mes y año
        const day = formattedDate.getDate();
        const month = formattedDate.getMonth() + 1; // Los meses en JavaScript son indexados desde 0
        const year = formattedDate.getFullYear();
        // Formatear la fecha en el formato "DD/MM/AAAA"
        return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    };

    if (isSearching) {
        return <div>
        <div className='top-bar2'>
            <div className="top-bar">
                <div className="logo">
                    {/* Botón con apariencia de logo que lleva a la página principal */}
                    <Link to="/">
                        <button className="logo-button">
                            <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                        </button>
                    </Link>
                </div>
            </div>
        </div><p className='padron'>Realizando búsqueda...</p>;            </div>

    }

    return (
        <div>
            <div className='top-bar2'>
                <div className="top-bar">
                    <div className="logo">
                        {/* Botón con apariencia de logo que lleva a la página principal */}
                        <Link to="/">
                            <button className="logo-button">
                                <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="acta-container">
                <h1>Padron RPP</h1>
                {result.map((res, index) => (
                    <div key={index}>
                        <h1>{res.NOMBRE}</h1>
                        <div className="acta" >
                            <div className='column'>

                                <h1> Nombre</h1>
                                <p className="letra"> {res.NOMBRE}</p>
                                <h1> RFC</h1>
                                <p className="letra"> {res.RFC}</p>
                                <h1> Folio</h1>
                                <p className="letra"> {res.FOLIO_REAL}</p>
                                <h1>Municipio</h1>
                                <p className="letra">{res.MUNICIPIO_DESCR}</p>
                                <h1> Colonia</h1>
                                <p className="letra"> {res.COLONIA}</p>
                                <h1> Ubicacion</h1>
                                <p className="letra">{res.UBICACION}</p>
                                <h1> Lote y Numero Oficial</h1>
                                <p className="letra"> {res.LOTE_Y_NUM_OFICIAL}</p>
                                <h1> Representante</h1>
                                <p className="letra"> {res.REPRESENTANTE}</p>


                            </div>
                            <div className='column'>
                                <h1> Regimen</h1>
                                <p className="letra"> {res.REGIMEN_DESCR}</p>
                                <h1> Indiviso</h1>
                                <p className="letra"> {res.INDIVISO}</p>
                                <h1> Porsentaje:</h1>
                                <p className="letra"> {res.PORCENTAJE}</p>
                                <h1> Tipo Predio</h1>
                                <p className="letra"> {res.TIPO_PREDIO_DESCR}</p>
                                <h1> Tipo Dueño</h1>
                                <p className="letra"> {res.TIPO_DUENO_DESCR}</p>
                                <h1> Tipo Regimen </h1>
                                <p className="letra"> {res.TIPO_REGIMEN_DESCR}</p>
                                <h1> Regimen</h1>
                                <p className="letra"> {res.REGIMEN_DESCRIPCION}</p>


                            </div>
                            <div className='column'>
                                <h1> Clave Castral</h1>
                                <p className="letra"> {res.CLAVE_CATASTRAL}</p>
                                <h1> Superficie</h1>
                                <p className="letra"> {res.SUPERFICIE}</p>
                                <h1> Medida de Superficie</h1>
                                <p className="letra"> {res.MEDIDA_SUP_DESCR}</p>
                                <h1> Construccion</h1>
                                <p className="letra"> {res.CONSTRUC}</p>
                                <h1> Superficei de Construccion</h1>
                                <p className="letra"> {res.SUP_CONSTR}</p>
                                <h1> Medida Superficei de Construccion</h1>
                                <p className="letra"> {res.MEDIDA_SUP_CONSTR_DESCR}</p>
                                <h1> Dominio de Propietario</h1>
                                <p className="letra"> {res.DOM_PROPIETARIO}</p>
                                <h1> Fecha de Adquisicion </h1>
                                <p className="letra">{formatDate(res.FECHA_ADQ)}</p>



                            </div>



                        </div>
                    </div>
                ))}

            </div>
        
        </div>
    )
}

export default withRouter(BusquedaRppDetalles)